import { render, staticRenderFns } from "./FormTemplateEditor.vue?vue&type=template&id=3d0ad7a6&scoped=true&"
import script from "./FormTemplateEditor.vue?vue&type=script&lang=js&"
export * from "./FormTemplateEditor.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplateEditor.vue?vue&type=style&index=0&id=3d0ad7a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0ad7a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
